import React, { useState, useEffect, useContext } from "react";
import Button from "../Button";
import handleMintInput from "./handleMintInput";
import showRemainingSupply, { getMaxSupply } from "./showRemainingSupply";
import { hooks as mHooks } from "../../wallet/metamask";
import { hooks as wHooks } from "../../wallet/walletconnect";
import AppContext from "../../AppContext";
import { handleMint } from "./minting";
import Info from "./Info";

const Main = () => {
	const { walletChoice, setManualError, setFundsError, setDeniedError } = useContext(AppContext);
	const [loading, setLoading] = useState(false);

	const { useProvider, useError } =
		walletChoice === "metamask" ? mHooks : walletChoice === "walletconnect" ? wHooks : mHooks;

	const provider = useProvider();
	const error = useError();

	const [mintInputAmount, setInutMintAmount] = useState(1);
	const [mintInputAmountError, setInutMintAmountError] = useState("");

	const [remainingSupply, setRemainingSupply] = useState("---");
	const [maxSupply, setMaxSupply] = useState("---");

	const [infoError, setInfoError] = useState("");
	const [infoMessage, setInfoMessage] = useState("");

	useEffect(() => {
		setInutMintAmountError(handleMintInput(mintInputAmount));
	}, [mintInputAmount]);

	useEffect(() => {
		const getRemainingSupply = async () => {
			setRemainingSupply(await showRemainingSupply());
		};
		getRemainingSupply();
	}, []);

	useEffect(() => {
		const _getMaxSupply = async () => {
			setMaxSupply(await getMaxSupply());
		};
		_getMaxSupply();
	}, []);

	useEffect(() => {
		if (infoError) {
			setTimeout(() => {
				setInfoError("");
			}, 2500);
		}
	}, [infoError]);

	return (
		<div className="p-4 flex place-items-center">
			<div className="w-full lg:w-9/12 2xl:w-6/12 m-auto flex flex-col place-items-center gap-y-4">
				<h2 className="text-3xl font-medium lg:font-bold uppercase text-center">
					Pick your blindfold
				</h2>
				<div className="order-2 md:order-none flex flex-col place-items-center pb-4 md:p-0 gap-y-2">
					<div className="flex flex-col gap-y-8 font-bold text-4xl place-items-center rounded-md p-2">
						<p className="">
							{(parseInt(remainingSupply)-1) || "---"}/{maxSupply}
						</p>
						<div className="w-full m-auto flex justify-center items-center gap-x-4">
							<div
								className="rounded-full gradient p-2 md:p-3 cursor-pointer drop-shadow-lg order-last"
								onClick={() => {
									setInutMintAmount(parseInt(mintInputAmount) + 1);
								}}>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className="h-6 w-6"
									fill="none"
									viewBox="0 0 24 24"
									stroke="currentColor">
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth={2}
										d="M12 4v16m8-8H4"
									/>
								</svg>
							</div>
							<input
								type="number"
								className={`rounded-lg w-3/12 text-center p-1 md:p-2 outline-none drop-shadow-lg ${
									mintInputAmountError ? "border-2 border-red-500" : ""
								}`}
								min="0"
								step="1"
								inputMode="numeric"
								value={mintInputAmount}
								onChange={(e) => {
									setInutMintAmountError(handleMintInput(e.target.value));
									setInutMintAmount(e.target.value);
								}}
							/>
							<div
								className="rounded-full gradient p-2 md:p-3 cursor-pointer  drop-shadow-lg order-first"
								onClick={() => {
									setInutMintAmount(parseInt(mintInputAmount) - 1);
								}}>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className="h-6 w-6"
									fill="none"
									viewBox="0 0 24 24"
									stroke="currentColor">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
								</svg>
							</div>
						</div>
					</div>
					<div className="text-center">{mintInputAmountError}</div>
					<Button
						text={"MINT"}
						classes="!px-8 md:!px-16 gradient text-2xl md:text-4xl p-2 hover:gradient-reverse"
						disabled={mintInputAmountError || error ? true : false}
						onClick={() => {
							if (provider) {
								handleMint(
									mintInputAmount,
									provider,
									setManualError,
									setInfoMessage,
									setLoading,
									error,
									setFundsError,
									setDeniedError
								);
							} else {
								setInfoError("Wallet isn't connected.");
							}
						}}
					/>
				</div>
				<div className="order-last md:order-none text-center">
					{loading && "Loading..."}
					{infoError && <Info error={infoError} message={infoMessage} />}
					{infoMessage && <Info message={infoMessage} />}
				</div>
			</div>
		</div>
	);
};

export default Main;
